module.exports = __webpack_public_path__ + "img/simOpen108.43df044d.png";